export default __webpack_public_path__ + "static/media/Jenny_Timur-171_websize.1254e41d.jpg";